import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Icon } from "@iconify/react";

const Dashboardmain = (props) => {
  console.log("hello")
  const [fileUploaded, setFileUploaded] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [iswholeChecked, setIswholeChecked] = useState(false);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handlewholeCheckboxChange = () => {
    setIswholeChecked(!iswholeChecked);
  };

  const handleFileUpload = () => {
    document.getElementById("fileInput").click();
  };
  const handleFileInputChange = (event) => {
    const selectedFile = event.target.files[0];
    console.log("Selected File:", selectedFile);
    setFileUploaded(true);
    props.onFileUpload();
  };

  return (
    <>
      <Outlet />
    </>
  );
};

export default Dashboardmain;
